document.addEventListener('DOMContentLoaded', () => {
  window.showTab = (id, element) => {
    document.querySelectorAll('.tab').forEach(tab => tab.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(panel => panel.classList.remove('active'));
    element.classList.add('active');
    document.getElementById(id)?.classList.add('active');
  };
  document.querySelectorAll('button[aria-expanded]').forEach(button => {
    button.addEventListener('click', () => button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'));
  });
  document.querySelectorAll('media-gallery').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('.product__media-list .product__media-item')];
    const thumbnails = [...gallery.querySelectorAll('.thumbnail-list__item button')];
    if (!slides.length) return;
    let selected = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    const show = index => {
      selected = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach((slide, position) => slide.classList.toggle('is-active', position === selected));
      thumbnails.forEach((button, position) => {
        if (position === selected) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      gallery.querySelector('.slider-counter--current')?.replaceChildren(String(selected + 1));
      gallery.querySelector('[role="status"]')?.replaceChildren(`Image ${selected + 1} of ${slides.length}`);
      thumbnails[selected]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    thumbnails.forEach((button, index) => button.addEventListener('click', () => show(index)));
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    viewer?.querySelector('.slider-button--prev')?.addEventListener('click', () => show(selected - 1));
    viewer?.querySelector('.slider-button--next')?.addEventListener('click', () => show(selected + 1));
    const strip = gallery.querySelector('slider-component[id^="GalleryThumbnails-"]');
    strip?.querySelector('.slider-button--prev')?.addEventListener('click', () => show(selected - 1));
    strip?.querySelector('.slider-button--next')?.addEventListener('click', () => show(selected + 1));

    const modal = document.querySelector(gallery.querySelector('modal-opener')?.dataset.modal || '');
    if (!modal) return;
    const close = () => {
      modal.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    };
    gallery.querySelectorAll('modal-opener').forEach((opener, index) => {
      opener.addEventListener('click', () => {
        show(index);
        modal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        modal.querySelectorAll('.product-media-modal__content [data-media-id]')[index]?.scrollIntoView({ block: 'start' });
        modal.querySelector('.product-media-modal__dialog')?.focus();
      });
    });
    modal.querySelector('.product-media-modal__toggle')?.addEventListener('click', close);
    modal.addEventListener('click', event => { if (event.target === modal) close(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && modal.hasAttribute('open')) close(); });
  });
  document.querySelectorAll('quantity-input').forEach(control => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    control.querySelectorAll('button[name="minus"], button[name="plus"]').forEach(button => {
      button.addEventListener('click', () => {
        const step = Number(input.step) || 1;
        const minimum = input.min === '' ? 1 : Number(input.min);
        const maximum = input.max === '' ? Infinity : Number(input.max);
        const next = Number(input.value || minimum) + (button.name === 'plus' ? step : -step);
        input.value = String(Math.max(minimum, Math.min(maximum, next)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
  document.querySelectorAll('#backToTop').forEach(button => {
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  });
  document.querySelectorAll('[id^="how-it-works-"]').forEach(container => {
    const tabs = [...container.querySelectorAll('[class*="ai-how-it-works-tab-"][data-stage]')];
    const panels = [...container.querySelectorAll('[class*="ai-how-it-works-panel-"][data-panel]')];
    const dots = [...container.querySelectorAll('[class*="ai-how-it-works-dot-"][data-dot]')];
    const wrapper = container.querySelector('[class*="ai-how-it-works-panels-wrapper-"]');
    if (!tabs.length || !wrapper) return;
    let stage = Number(container.querySelector('[data-stage].active')?.dataset.stage || 1);
    const show = next => {
      stage = Math.max(1, Math.min(tabs.length, next));
      tabs.forEach(tab => tab.classList.toggle('active', Number(tab.dataset.stage) === stage));
      panels.forEach(panel => panel.classList.toggle('active', Number(panel.dataset.panel) === stage));
      dots.forEach(dot => dot.classList.toggle('active', Number(dot.dataset.dot) === stage));
      wrapper.style.transform = `translateX(-${(stage - 1) * 100}%)`;
    };
    tabs.forEach(tab => tab.addEventListener('click', () => show(Number(tab.dataset.stage))));
    dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.dot))));
    let startX = 0;
    wrapper.addEventListener('touchstart', event => { startX = event.changedTouches[0].screenX; }, { passive: true });
    wrapper.addEventListener('touchend', event => {
      const distance = startX - event.changedTouches[0].screenX;
      if (Math.abs(distance) > 50) show(stage + Math.sign(distance));
    }, { passive: true });
  });
  document.querySelectorAll('.swiper[class*="testimonials-slider-"]').forEach(slider => {
    const wrapper = slider.querySelector('.swiper-wrapper');
    const slides = [...slider.querySelectorAll('.swiper-slide')];
    const controls = slider.parentElement;
    if (!wrapper || !slides.length) return;
    const previous = controls.querySelector('button[class*="testimonials-btn-prev-"]');
    const next = controls.querySelector('button[class*="testimonials-btn-next-"]');
    const pagination = slider.querySelector('.swiper-pagination');
    let index = 0;
    let step = 0;
    let limit = 0;
    slider.classList.remove('preview');
    slider.style.overflow = 'hidden';
    wrapper.style.display = 'flex';
    wrapper.style.transition = 'transform 350ms ease';
    wrapper.style.justifyContent = 'flex-start';
    const render = () => {
      const offset = Math.min(index * step, limit);
      wrapper.style.transform = `translate3d(-${offset}px, 0, 0)`;
      previous?.classList.toggle('swiper-button-disabled', index === 0);
      next?.classList.toggle('swiper-button-disabled', offset >= limit - 1);
      pagination?.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, position) => {
        bullet.classList.toggle('swiper-pagination-bullet-active', position === index);
      });
    };
    const layout = () => {
      const width = slider.clientWidth;
      const count = width >= 1024 ? 3.7 : width >= 768 ? 1.85 : 1;
      const gap = width >= 1024 ? 36 : 20;
      step = (width - gap * (count - 1)) / count + gap;
      wrapper.style.gap = `${gap}px`;
      slides.forEach(slide => { slide.style.flex = `0 0 ${step - gap}px`; slide.style.margin = '0'; });
      limit = Math.max(0, slides.length * step - gap - width);
      render();
    };
    if (pagination) {
      pagination.replaceChildren(...slides.map((_, position) => {
        const bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-label', `Go to testimonial ${position + 1}`);
        bullet.addEventListener('click', () => { index = position; render(); });
        return bullet;
      }));
    }
    previous?.addEventListener('click', () => { index = Math.max(0, index - 1); render(); });
    next?.addEventListener('click', () => { index = Math.min(slides.length - 1, index + 1); render(); });
    window.addEventListener('resize', layout);
    layout();
  });
  const image = document.querySelector('#msc-main');
  const stickyImage = document.querySelector('#msc-sticky-img');
  const thumbs = [...document.querySelectorAll('#msc-thumbs .msc-thumb')];
  let current = 0;
  if (image && thumbs.length) {
    const show = index => {
      current = (index + thumbs.length) % thumbs.length;
      const source = thumbs[current].dataset.src;
      if (!source) return;
      image.src = source;
      if (stickyImage) stickyImage.src = source;
      thumbs.forEach((thumb, thumbIndex) => {
        const selected = thumbIndex === current;
        thumb.classList.toggle('on', selected);
        thumb.setAttribute('aria-pressed', String(selected));
        thumb.style.borderColor = selected ? '#C7A76A' : 'transparent';
      });
      const strip = thumbs[current].parentElement;
      if (strip) {
        const thumbLeft = thumbs[current].getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
        strip.scrollTo({ left: thumbLeft - strip.clientWidth / 2 + thumbs[current].clientWidth / 2, behavior: 'smooth' });
      }
    };
    document.querySelector('#msc-prev')?.addEventListener('click', () => show(current - 1));
    document.querySelector('#msc-next')?.addEventListener('click', () => show(current + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
  }
  const variantId = document.querySelector('#MainContent')?.dataset.msVariant;
  if (variantId) {
    const selectedVariantId = () => document.querySelector('variant-selects input[type="radio"][data-ms-variant-id]:checked')?.dataset.msVariantId
      || document.querySelector('[data-pureliv-form] input[name="id"]:checked')?.value
      || variantId;
    const updateVariant = () => {
      const selected = selectedVariantId();
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"][type="hidden"]').forEach(input => { input.value = selected; });
      document.querySelectorAll('a[data-product11-buy]').forEach(link => { link.href = `/cart/add?id=${selected}&quantity=1`; });
    };
    document.querySelectorAll('variant-selects input[type="radio"], [data-pureliv-form] input[name="id"]').forEach(input => {
      input.addEventListener('change', updateVariant);
    });
    updateVariant();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', updateVariant, true);
      form.querySelector('button[type="submit"]')?.addEventListener('pointerdown', updateVariant, true);
    });
    document.querySelectorAll('a[href^="/cart/:"]').forEach(link => {
      link.href = `/cart/add?id=${variantId}&quantity=1`;
    });
  }
  const deliveryDate = document.querySelector('#ub-delivery-date');
  const countdown = document.querySelector('#ub-countdown');
  if (deliveryDate && countdown) {
    const timezone = 'America/New_York';
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: timezone }));
    const delivery = new Date(now.getTime());
    delivery.setDate(delivery.getDate() + 7);
    const weekday = delivery.toLocaleString('en-US', { weekday: 'long', timeZone: timezone });
    const day = delivery.toLocaleString('en-US', { day: 'numeric', timeZone: timezone });
    const month = delivery.toLocaleString('en-US', { month: 'short', timeZone: timezone });
    deliveryDate.textContent = `${weekday}, ${day} ${month}`;
    const tick = () => {
      const hours = Math.floor(Math.random() * 2);
      const minutes = Math.floor(Math.random() * 60);
      countdown.textContent = `${hours} ${hours === 1 ? 'HOUR' : 'HOURS'} ${String(minutes).padStart(2, '0')} MINUTES`;
    };
    tick();
    setInterval(tick, 30000);
  }
  document.querySelector('#ms-track-submit')?.addEventListener('click', () => {
    document.querySelector('#ms-track-message')?.removeAttribute('hidden');
  });
});

// Links de compra (/cart/add?id=…) abrem a gaveta do UpCart em vez da página /cart.
// Sem JS o link continua funcionando (adiciona e vai para /cart).
(() => {
  const drawerVisible = () => {
    const popup = document.querySelector('#upCart')?.shadowRoot?.querySelector('#CartPopup');
    if (!popup) return false;
    const rect = popup.getBoundingClientRect();
    return rect.width > 0 && rect.left < window.innerWidth && rect.right > 0;
  };
  let busy = false;
  document.addEventListener('click', async event => {
    const link = event.target.closest?.('a[href*="/cart/add?id="]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey) return;
    const url = new URL(link.href, window.location.origin);
    const id = Number(url.searchParams.get('id'));
    if (!id) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: Number(url.searchParams.get('quantity')) || 1 }] })
      });
      if (!response.ok) throw new Error('cart/add ' + response.status);
      if (typeof window.upcartRefreshCart === 'function') await Promise.resolve(window.upcartRefreshCart()).catch(() => {});
      if (!drawerVisible() && typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
      // Se a gaveta não aparecer (app bloqueado ou lento), o item já está no carrinho: mandar para /cart.
      setTimeout(() => { if (!drawerVisible()) window.location.href = '/cart'; busy = false; }, 2500);
    } catch (error) {
      busy = false;
      window.location.href = link.href;
    }
  }, true);
})();
